import LegalDocumentPage from "./LegalDocumentPage";

export default function Terms() {
  return <LegalDocumentPage documentKey="terms" />;
}
